import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AiOutlineLaptop } from 'react-icons/ai'
import { Button, Container, Grid, Icon, Message } from 'semantic-ui-react'
import { useEditHandleError } from '../../Common/Hooks/useEditHandleError'
import {
  loadPlatformById,
  newPlatform,
  savePlatform,
  updateState
} from '../Slice/PlatformSlice'
import { PlatformForm } from '../Form/PlatformForm'
import './css/PlatformListPage.css'

export default function PlatformEditPage () {
  const { t } = useTranslation()
  const {
    isLoading,
    isSuccess,
    isError,
    message
  } = useSelector((state) => state.platform)
  const dispatch = useDispatch()
  const { platformId } = useParams()
  const [errorList, goBack, handleError] = useEditHandleError('/platform')

  useEffect(() => {
    if (platformId === 'new') {
      dispatch(newPlatform())
    } else {
      dispatch(loadPlatformById(platformId))
    }
  }, [])

  useEffect(() => {
    handleError(isSuccess, isError, message)
    dispatch(updateState())
  }, [isSuccess, isError, message])

  const onSavePlatform = () => {
    dispatch(savePlatform())
  }

  return (
    <Container className='platform-list-page'>
      <div className='platform-title platform-division'>
        <Grid columns={2}>
          <Grid.Column>
            <Icon size='large'><AiOutlineLaptop /></Icon>
            {
              platformId === 'new'
                ? (<span>{ t('platform.new') }</span>)
                : (<>
                    <span>{ t('platform.edit') }</span>
                    <small className='mx-3'># { platformId }</small>
                  </>)
            }
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button
              icon
              labelPosition='left'
              color='grey'
              size='large'
              disabled={isLoading}
              onClick={goBack}>
              <Icon name='arrow circle left' /> { t('generic.goBack') }
            </Button>
            <Button
              icon
              labelPosition='left'
              color='green'
              size='large'
              disabled={isLoading}
              onClick={onSavePlatform}>
              <Icon name='save' /> { t('generic.save') }
            </Button>
          </Grid.Column>
        </Grid>
      </div>
      <div className='p-4'>
        <PlatformForm />
      </div>
      <div className='p-4'>
        { errorList.length > 0 &&
          <Message error icon='exclamation triangle'
                   header={ t('generic.validation.onSave') }
                   list={errorList} />
        }
      </div>
    </Container>
  )
}
